import { render, staticRenderFns } from "./selectArea.vue?vue&type=template&id=22933510&scoped=true&"
import script from "./selectArea.vue?vue&type=script&lang=js&"
export * from "./selectArea.vue?vue&type=script&lang=js&"
import style0 from "./selectArea.vue?vue&type=style&index=0&id=22933510&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22933510",
  null
  
)

export default component.exports